module.exports = __webpack_public_path__ + "img/zloty_ikonica.68a23bfd.svg";